var getElem = setInterval(function () {
//   document.querySelectorAll('.Engraving').forEach(engraving => {
//     engraving.removeAttribute('style');
//     engraving.querySelectorAll('input[type="text"]').forEach(input => {
//         input.removeAttribute('disabled');
//         input.removeAttribute('required');
//     });
// });
}, 10);

// Scroll to target
document.addEventListener('DOMContentLoaded', function() {
  let announcementBar = document.querySelector('.announcement-sticky-wrapper');
  let header = document.querySelector('.header');

  let announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
  let headerHeight = header ? header.offsetHeight : 0;
  let deskTotalHeight = headerHeight + announcementBarHeight;

  document.querySelectorAll('.scrollTo').forEach(function(element) {
    element.addEventListener('click', function(e) {
      e.preventDefault();

      let targetId = element.getAttribute('href');
      let targetElement = document.querySelector(targetId);

      if (targetElement) {
        let newPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        let scrollPosition = newPosition - deskTotalHeight;

        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });

        setTimeout(() => {
          let adjustedPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - deskTotalHeight;
          window.scrollTo({ top: adjustedPosition, behavior: 'smooth' });
        }, 800);
      }
    });
  });
});

function waitForElement(selector, callback, interval) {
  interval = interval || 100;
  let checkExist = setInterval(function () {
    let element = document.querySelector(selector);
    if (element) {
      clearInterval(checkExist);
      callback(element);
    }
  }, interval);
}

// Wait for input[name-disabled="properties[Engraving Text]"]
waitForElement('input[name-disabled="properties[Engraving Text]"]', function (input) {
  input.addEventListener('keyup', function (event) {
    let engravingField = document.querySelector('[name="properties[Engraving]"]');
    let productPriceElement = document.querySelector(".variant-selection__variants");
    let engravingProductPrice = document.body.getAttribute("data-engraving-product");
    let selectedOption = productPriceElement.options[productPriceElement.selectedIndex];
    let productPrice = selectedOption.getAttribute("data-price-without-formate");
    let productOrignalPrice = selectedOption.getAttribute("data-price-with-formate");
    let totalPrice = (parseFloat(productPrice) || 0) + (parseFloat(engravingProductPrice) || 0);
    let moneyFormat = document.body.getAttribute("data-money-format");
    let formattedPrice = Shopify.formatMoney(totalPrice, moneyFormat);
    let orignalPrice = Shopify.formatMoney(productPrice, moneyFormat);
    let priceElementt = document.querySelector(".engraving-product-addition--price");

    if (engravingField && input.value.trim() !== '') {
      engravingField.value = 'Yes';
      if (priceElementt) {
        priceElementt.textContent = formattedPrice;
      }
      let engravingInput = document.querySelector('input[name-disabled="properties[Engraving Text]"]');
      if (engravingInput) {
        engravingInput.setAttribute('name', 'properties[Engraving Text]');
        engravingInput.removeAttribute('name-disabled');
      }
    } else {
      engravingField.value = 'No';
      priceElementt.textContent = orignalPrice;
    }
  });

  const selectElement = document.querySelector('select[name="properties[Engraving]"]');
  if (selectElement && selectElement.options.length > 0) {
    selectElement.options[0].textContent = "Add Engraving ($45)";
  }

  let label = document.querySelector('[for="Size-0-0"]');
  if (label) {
    let link = document.createElement('a');
    link.href = 'javascript:void(0)';
    link.className = 'identify-your-ring-size';
    link.setAttribute('data-fancybox', '');
    link.setAttribute('data-src', '#identifyYourRingSize');
    link.textContent = 'Identify your ring size';
    link.style.marginLeft = '10px';
    label.after(link);
  }

  var sizeSelect = document.getElementById("Size-0-0");
  if (!sizeSelect) return;

  if (label && label.parentNode.classList.contains('spb-label-tooltip')) {
    let parentNode = label.parentNode;
    let selectSizeWrapper = parentNode.querySelector('.select-size-button-wrapper');
    if (!selectSizeWrapper) {
      selectSizeWrapper = document.createElement("div");
      selectSizeWrapper.classList.add('select-size-button-wrapper');
      insertAfter(selectSizeWrapper, parentNode);
    }

    let existingSelecter = selectSizeWrapper.querySelector('.dropdown-select');
    if (selectSizeWrapper && !existingSelecter) {
      let existingSelecterWrap = selectSizeWrapper.querySelector('.cw-product-bundle__variant-select');
      if (!existingSelecterWrap) {
        let selecterWrap = document.createElement('div');
        selecterWrap.classList.add('cw-product-bundle__variant-select', 'dropdown-select', 'js-dropdown-select');

        let existingSelectedOption = selecterWrap.querySelector('.cw-product-bundle__variant-selected');
        if (!existingSelectedOption) {
          let selectedOption = document.createElement('div');
          selectedOption.classList.add('cw-product-bundle__variant-selected', 'dropdown-selected-option', 'js-selected-option');
          let selectedText = document.createElement('span');
          selectedText.classList.add('cw-product-bundle__variant-text', 'dropdown-selected-option-text');
          selectedText.textContent = 'Select Ring Size';
          selectedOption.appendChild(selectedText);
          selecterWrap.appendChild(selectedOption);
        }

        let existingOptionsWrapper = selecterWrap.querySelector('.cw-product-bundle__variant-options');
        if (!existingOptionsWrapper) {
          let optionsWrapper = document.createElement('div');
          optionsWrapper.classList.add('cw-product-bundle__variant-options', 'dropdown-options');
          selecterWrap.appendChild(optionsWrapper);
        }

        let existingHiddenInput = selecterWrap.querySelector('input[type="hidden"]');
        if (!existingHiddenInput) {
          let hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'selectedValue';
          hiddenInput.value = '';
          selecterWrap.appendChild(hiddenInput);
        }

        selectSizeWrapper.appendChild(selecterWrap);
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('size-error-message');
        errorMessage.textContent = 'Please select a ring size';
        errorMessage.style.display = 'none';
        selectSizeWrapper.appendChild(errorMessage);
      }
    }

    if (selectSizeWrapper.querySelector('.cw-product-bundle__variant-options')) {
      let placeholderOption = document.createElement("div");
      placeholderOption.classList.add('cw-product-bundle__variant-option', 'dropdown-option');
      placeholderOption.setAttribute('data-text', "");
      let placeholderText = document.createElement("span");
      placeholderText.classList.add('cw-product-bundle__option-text');
      placeholderText.textContent = "Select Ring Size";
      placeholderOption.appendChild(placeholderText);
      selectSizeWrapper.querySelector('.cw-product-bundle__variant-options').appendChild(placeholderOption);
      placeholderOption.classList.add("selected");

      for (let i = 0; i < sizeSelect.options.length; i++) {
        let option = sizeSelect.options[i];
        let value = option.value.trim();
        let text = option.text.trim();

        if (value) {
          let swatchBlock = document.createElement("div");
          swatchBlock.classList.add('cw-product-bundle__variant-option', 'dropdown-option');
          swatchBlock.setAttribute('data-text', value);
          let swatchOptionText = document.createElement("span");
          swatchOptionText.classList.add('cw-product-bundle__option-text');
          swatchOptionText.textContent = text;
          swatchBlock.appendChild(swatchOptionText);
          selectSizeWrapper.querySelector('.cw-product-bundle__variant-options').appendChild(swatchBlock);

          swatchBlock.addEventListener("click", function () {
            document.querySelectorAll(".dropdown-option").forEach(function(el) {
              el.classList.remove("selected");
            });
            this.classList.add("selected");
            sizeSelect.value = this.getAttribute("data-text");
            let changeEvent = new Event("change");
            sizeSelect.dispatchEvent(changeEvent);

            let selectedText = this.getAttribute('data-text') || '';
            let selectedHtml = '';
            if (selectedText) {
              selectedHtml += `<span class="dropdown-selected-option-text">${selectedText}</span>`;
            }
            let dropdownSelect = this.closest('.dropdown-select');
            let selectedOptionElement = dropdownSelect.querySelector('.dropdown-selected-option');
            if (selectedOptionElement) {
              selectedOptionElement.innerHTML = selectedHtml;
            }
            let hiddenInput = dropdownSelect.querySelector('input[type="hidden"]');
            if (hiddenInput) {
              hiddenInput.value = this.textContent;
            }
            let optionsContainer = this.parentElement;
            if (optionsContainer) {
              optionsContainer.style.display = 'none';
            }
            let jsSelectedOption = document.querySelector('.js-selected-option');
            if (jsSelectedOption && jsSelectedOption.classList.contains('is-select-dropdown-open')) {
              jsSelectedOption.classList.remove('is-select-dropdown-open');
            }
          });
        }
      }

      document.addEventListener('click', function(e) {
        let dropdownSelect = document.querySelector('.dropdown-select');
        let dropdownOptions = document.querySelectorAll('.dropdown-options');
        if (dropdownSelect && !dropdownSelect.contains(e.target)) {
          dropdownOptions.forEach(function(option) {
            option.style.display = 'none';
          });
        }
      });

      document.querySelectorAll('.js-selected-option').forEach(function(element) {
        element.addEventListener('click', function() {
          document.querySelectorAll('.dropdown-options').forEach(function(option) {
            if (option !== element.nextElementSibling) {
              option.style.display = 'none';
            }
          });
          let dropdownOptions = element.nextElementSibling;
          if (dropdownOptions.style.display === 'none' || dropdownOptions.style.display === '') {
            dropdownOptions.style.display = 'block';
            element.classList.add('is-select-dropdown-open');
          } else {
            dropdownOptions.style.display = 'none';
            element.classList.remove('is-select-dropdown-open');
          }
        });
      });
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Initialize metal color radio buttons from dropdown value — scoped per section
  document.querySelectorAll('.metal-custom--color').forEach(function(selectEl) {
    if (!selectEl.value) return;
    var section = selectEl.closest('[id*="shopify-section"]');
    if (!section) return;
    var radios = section.querySelectorAll('.custom-radio--color');
    radios.forEach(function(radio) {
      if (radio.value === selectEl.value) {
        radio.checked = true;
      }
    });
  });

  // var-size dropdown UI
  var sizeSelect = document.getElementById("var-size");
  if (!sizeSelect) return;
  let label = document.querySelector('[for="var-size"]');
  if (!label) return;
  if (label.parentNode.classList.contains('spb-label-tooltip')) {
    let parentNode = label.parentNode;
    let selectSizeWrapper = parentNode.querySelector('.select-size-button-wrapper');

    if (!selectSizeWrapper) {
      selectSizeWrapper = document.createElement("div");
      selectSizeWrapper.classList.add('select-size-button-wrapper');
      insertAfter(selectSizeWrapper, parentNode);
    }

    let existingSelecter = selectSizeWrapper.querySelector('.dropdown-select');
    if (selectSizeWrapper && !existingSelecter) {
      let existingSelecterWrap = selectSizeWrapper.querySelector('.cw-product-bundle__variant-select');
      if (!existingSelecterWrap) {
        let selecterWrap = document.createElement('div');
        selecterWrap.classList.add('cw-product-bundle__variant-select', 'dropdown-select', 'js-dropdown-select');

        let existingSelectedOption = selecterWrap.querySelector('.cw-product-bundle__variant-selected');
        if (!existingSelectedOption) {
          let selectedOption = document.createElement('div');
          selectedOption.classList.add('cw-product-bundle__variant-selected', 'dropdown-selected-option', 'js-selected-option');
          let selectedText = document.createElement('span');
          selectedText.classList.add('cw-product-bundle__variant-text', 'dropdown-selected-option-text');
          selectedText.textContent = 'Select Ring Size';
          selectedOption.appendChild(selectedText);
          selecterWrap.appendChild(selectedOption);
        }

        let existingOptionsWrapper = selecterWrap.querySelector('.cw-product-bundle__variant-options');
        if (!existingOptionsWrapper) {
          let optionsWrapper = document.createElement('div');
          optionsWrapper.classList.add('cw-product-bundle__variant-options', 'dropdown-options');
          selecterWrap.appendChild(optionsWrapper);
        }

        let existingHiddenInput = selecterWrap.querySelector('input[type="hidden"]');
        if (!existingHiddenInput) {
          let hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'selectedValue';
          hiddenInput.value = '';
          selecterWrap.appendChild(hiddenInput);
        }

        selectSizeWrapper.appendChild(selecterWrap);
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('size-error-message');
        errorMessage.textContent = 'Please select a ring size';
        errorMessage.style.display = 'none';
        selectSizeWrapper.appendChild(errorMessage);
      }
    }

    if (selectSizeWrapper.querySelector('.cw-product-bundle__variant-options')) {
      let placeholderOption = document.createElement("div");
      placeholderOption.classList.add('cw-product-bundle__variant-option', 'dropdown-option');
      placeholderOption.setAttribute('data-text', "");
      let placeholderText = document.createElement("span");
      placeholderText.classList.add('cw-product-bundle__option-text');
      placeholderText.textContent = "Select Ring Size";
      placeholderOption.appendChild(placeholderText);
      selectSizeWrapper.querySelector('.cw-product-bundle__variant-options').appendChild(placeholderOption);
      placeholderOption.classList.add("selected");

      for (let i = 0; i < sizeSelect.options.length; i++) {
        let option = sizeSelect.options[i];
        let value = option.value.trim();
        let text = option.text.trim();

        if (value) {
          let swatchBlock = document.createElement("div");
          swatchBlock.classList.add('cw-product-bundle__variant-option', 'dropdown-option');
          swatchBlock.setAttribute('data-text', value);
          let swatchOptionText = document.createElement("span");
          swatchOptionText.classList.add('cw-product-bundle__option-text');
          swatchOptionText.textContent = text;
          swatchBlock.appendChild(swatchOptionText);
          selectSizeWrapper.querySelector('.cw-product-bundle__variant-options').appendChild(swatchBlock);

          swatchBlock.addEventListener("click", function () {
            document.querySelectorAll(".dropdown-option").forEach(function(el) {
              el.classList.remove("selected");
            });
            this.classList.add("selected");
            sizeSelect.value = this.getAttribute("data-text");
            let changeEvent = new Event("change");
            sizeSelect.dispatchEvent(changeEvent);

            let selectedText = this.getAttribute('data-text') || '';
            let selectedHtml = '';
            if (selectedText) {
              selectedHtml += `<span class="dropdown-selected-option-text">${selectedText}</span>`;
            }
            let dropdownSelect = this.closest('.dropdown-select');
            let selectedOptionElement = dropdownSelect.querySelector('.dropdown-selected-option');
            if (selectedOptionElement) {
              selectedOptionElement.innerHTML = selectedHtml;
            }
            let hiddenInput = dropdownSelect.querySelector('input[type="hidden"]');
            if (hiddenInput) {
              hiddenInput.value = this.textContent;
            }
            let optionsContainer = this.parentElement;
            if (optionsContainer) {
              optionsContainer.style.display = 'none';
            }
            let jsSelectedOption = document.querySelector('.js-selected-option');
            if (jsSelectedOption && jsSelectedOption.classList.contains('is-select-dropdown-open')) {
              jsSelectedOption.classList.remove('is-select-dropdown-open');
            }
          });
        }
      }

      document.addEventListener('click', function(e) {
        let dropdownSelect = document.querySelector('.dropdown-select');
        let dropdownOptions = document.querySelectorAll('.dropdown-options');
        if (dropdownSelect && !dropdownSelect.contains(e.target)) {
          dropdownOptions.forEach(function(option) {
            option.style.display = 'none';
          });
        }
      });

      document.querySelectorAll('.js-selected-option').forEach(function(element) {
        element.addEventListener('click', function() {
          document.querySelectorAll('.dropdown-options').forEach(function(option) {
            if (option !== element.nextElementSibling) {
              option.style.display = 'none';
            }
          });
          let dropdownOptions = element.nextElementSibling;
          if (dropdownOptions.style.display === 'none' || dropdownOptions.style.display === '') {
            dropdownOptions.style.display = 'block';
            element.classList.add('is-select-dropdown-open');
          } else {
            dropdownOptions.style.display = 'none';
            element.classList.remove('is-select-dropdown-open');
          }
        });
      });
    }
  }
});

document.addEventListener('change', function(event) {
  if (event.target.name === "properties[Engraving]") {
    let engravingInput = document.querySelector('[name="properties[Engraving Text]"]');
    if (!engravingInput) return;
    engravingInput.value = '';
    engravingInput.textContent = '';
    let productPriceElement = document.querySelector(".variant-selection__variants");
    let engravingProductPrice = document.body.getAttribute("data-engraving-product");
    let selectedOption = productPriceElement.options[productPriceElement.selectedIndex];
    let productPrice = selectedOption.getAttribute("data-price-without-formate");
    let totalPrice = (parseFloat(productPrice) || 0) + (parseFloat(engravingProductPrice) || 0);
    let moneyFormat = document.body.getAttribute("data-money-format");
    let formattedPrice = Shopify.formatMoney(totalPrice, moneyFormat);
    let orignalPrice = Shopify.formatMoney(productPrice, moneyFormat);
    let priceElementt = document.querySelector(".engraving-product-addition--price");
    if (!priceElementt) return;
    if (event.target.value.toLowerCase() === "no") {
      priceElementt.textContent = orignalPrice;
    }
    if (event.target.value.toLowerCase() === "yes" && engravingInput && engravingInput.value.trim() !== '') {
      priceElementt.textContent = formattedPrice;
    }
  }
});

// Metal color radio → scoped dropdown sync (delegated, works regardless of DOM timing)
document.addEventListener('change', function(e) {
  if (!e.target.classList.contains('custom-radio--color')) return;
  var section = e.target.closest('[id*="shopify-section"]');
  var dropdown = section ? section.querySelector('.metal-custom--color') : null;
  if (dropdown) {
    dropdown.value = e.target.value;
    dropdown.dispatchEvent(new Event('change', { bubbles: false }));
  }
});

// Metal color label display — scoped per section
document.addEventListener('change', function(e) {
  if (!e.target.classList.contains('custom-radio--color')) return;
  var section = e.target.closest('[id*="shopify-section"]');
  if (!section) return;
  var colorSwatchLabel = section.querySelector('.selector-wrapper .spb-label-tooltip label[for^="data-variant-option-0"]');
  if (!colorSwatchLabel) return;
  var inputVal = e.target.getAttribute('data-color-value');
  if (!inputVal) return;
  updateSelectedColorValue(colorSwatchLabel, inputVal.trim());
});

let productSection = document.querySelector('.product_section');

function elementInViewport() {
  window.addEventListener('scroll', function() {
    if (productSection) {
      let bounding = productSection.getBoundingClientRect();
      let sectionHeight = productSection.offsetHeight - 115;
      let sectionWidth = productSection.offsetWidth;
      let atcBtn = document.querySelector('.purchase-details__buttons button.action_button');
      if (!atcBtn) return;

      if (bounding.top >= -sectionHeight &&
        bounding.left >= -sectionWidth &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + sectionWidth &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + sectionHeight) {
        atcBtn.classList.remove('is-active-sticky-atc');
      } else {
        atcBtn.classList.add('is-active-sticky-atc');
      }
    }
  });
}

function waitToElement(selector, trigger, delayInterval, delayTimeout) {
  let interval = setInterval(function () {
    if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
      clearInterval(interval);
      trigger();
    }
  }, delayInterval);
  setTimeout(function () {
    clearInterval(interval);
  }, delayTimeout);
}

function onLoadFlickityLibrary(trigger, delayInterval, delayTimeout) {
  let interval = setInterval(function () {
    if (typeof Flickity !== 'undefined') {
      clearInterval(interval);
      trigger();
    }
  }, delayInterval);
  setTimeout(function () {
    clearInterval(interval);
  }, delayTimeout);
}

function productGalleryflickty() {
  let flickityInstance = Flickity.data(document.querySelector('.product-gallery__main'));
  if (!flickityInstance) return;
  flickityInstance.options.cellAlign = 'left';
  flickityInstance.resize();
}

window.onload = function() {
  if (productSection && window.innerWidth < 768) {
    elementInViewport();
  }
  if (window.innerWidth <= 750) {
    onLoadFlickityLibrary(function () {
      waitToElement('.product-gallery__main', productGalleryflickty, 600, 8000);
    }, 250, 6000);
  }
};

function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

function insertBefore(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode);
}

// updateSelectedColorValue now takes an explicit label element (scoped per section)
function updateSelectedColorValue(colorSwatchLabel, inputValue) {
  if (!colorSwatchLabel) return;
  var parentNode = colorSwatchLabel.parentNode;

  if (parentNode.classList.contains('spb-label-tooltip') && !parentNode.classList.contains('spb-label-select-val')) {
    parentNode.classList.add('spb-label-select-val');
  }

  let selectedColor = parentNode.querySelector('.selected-color-swatch-val');
  if (!selectedColor) {
    selectedColor = document.createElement('span');
    selectedColor.classList.add('selected-color-swatch-val');
    parentNode.insertBefore(selectedColor, colorSwatchLabel.nextSibling);
  }

  selectedColor.textContent = inputValue;

  let checkColoneTag = parentNode.querySelector('i');
  if (!checkColoneTag) {
    let iTag = document.createElement('i');
    iTag.textContent = ':';
    insertBefore(iTag, selectedColor);
  }
}

function colorSwatchSelectedVal() {
  // Run for each section independently
  document.querySelectorAll('[id*="shopify-section"]').forEach(function(section) {
    var selectedInput = section.querySelector('.cus-variant-ui .custom-radio--color:checked');
    if (!selectedInput || !selectedInput.value) return;
    var colorSwatchLabel = section.querySelector('.selector-wrapper .spb-label-tooltip label[for^="data-variant-option-0"]');
    if (!colorSwatchLabel) return;
    updateSelectedColorValue(colorSwatchLabel, selectedInput.getAttribute('data-color-value').trim());
  });
}

waitToElement('.cus-variant-ui .custom-radio--color:checked', colorSwatchSelectedVal, 100, 10000);

document.addEventListener('click', function(event) {
  const target = event.target.closest('.cw-product-bundle__variant-option');
  if (target) {
    const selectedText = target.getAttribute('data-text');
    const errorMessage = document.querySelector('.size-error-message');
    if (errorMessage) {
      errorMessage.style.display = (selectedText !== 'Select Ring Size') ? 'none' : 'block';
    }
  }
});

window.addEventListener('load', function () {
  const originalSelect = document.querySelector('.js-single-option-selector--caret');
  if (!originalSelect) return;

  const dropdownWrapper = document.createElement('div');
  dropdownWrapper.className = 'custom-dropdown';
  dropdownWrapper.id = 'custom-ring-size-dropdown';

  const selectedDiv = document.createElement('div');
  selectedDiv.className = 'cw-product-bundle__variant-selected dropdown-selected-option--carat js-selected-option1';
  const selectedSpan = document.createElement('span');
  selectedSpan.className = 'cw-product-bundle__variant-text dropdown-selected-option-text';
  selectedSpan.textContent = 'Select Stone Carat';
  selectedDiv.appendChild(selectedSpan);
  dropdownWrapper.appendChild(selectedDiv);

  const optionsContainer = document.createElement('div');
  optionsContainer.className = 'custom-options-container';
  optionsContainer.style.display = 'none';

  function createOptionDiv(text, value, isSelected) {
    const optionDiv = document.createElement('div');
    optionDiv.className = 'cw-product-bundle__variant-option dropdown-option';
    if (isSelected) optionDiv.classList.add('selected');
    optionDiv.dataset.text = value;
    const optionSpan = document.createElement('span');
    optionSpan.className = 'cw-product-bundle__option-text';
    optionSpan.textContent = text;
    optionDiv.appendChild(optionSpan);
    return optionDiv;
  }

  Array.from(originalSelect.options).forEach(function(option) {
    const optionDiv = createOptionDiv(option.textContent, option.value);
    optionsContainer.appendChild(optionDiv);
  });

  dropdownWrapper.appendChild(optionsContainer);

  const targetContainer = document.querySelector('.js-caret--select');
  if (targetContainer) {
    targetContainer.appendChild(dropdownWrapper);
  }

  const errorSpan = document.createElement('span');
  errorSpan.className = 'error-message--carat';
  errorSpan.textContent = 'Please select carat size.';
  errorSpan.style.color = 'red';
  errorSpan.style.fontSize = '15px';
  errorSpan.style.marginTop = '6px';
  errorSpan.style.display = 'none';
  dropdownWrapper.insertAdjacentElement('afterend', errorSpan);

  selectedDiv.addEventListener('click', function () {
    const isOpen = window.getComputedStyle(optionsContainer).display === 'block';
    if (isOpen) {
      optionsContainer.style.display = 'none';
      selectedDiv.classList.remove('is-select-dropdown-open');
    } else {
      optionsContainer.style.display = 'block';
      selectedDiv.classList.add('is-select-dropdown-open');
    }
  });

  optionsContainer.addEventListener('click', function (e) {
    const clickedOption = e.target.closest('.cw-product-bundle__variant-option');
    if (!clickedOption) return;
    if (clickedOption.classList.contains('disabled-option')) return;

    const selectedText = clickedOption.querySelector('.cw-product-bundle__option-text').textContent;
    const selectedValue = clickedOption.dataset.text;

    document.querySelectorAll('.cw-product-bundle__variant-option').forEach(function(opt) {
      opt.classList.remove('selected');
    });
    clickedOption.classList.add('selected');
    selectedSpan.textContent = selectedText;
    errorSpan.style.display = 'none';

    originalSelect.value = selectedValue;
    originalSelect.dispatchEvent(new Event('change', { bubbles: true }));

    optionsContainer.style.display = 'none';
    selectedDiv.classList.remove('is-select-dropdown-open');
  });

  document.addEventListener('click', function (e) {
    if (!dropdownWrapper.contains(e.target)) {
      optionsContainer.style.display = 'none';
      selectedDiv.classList.remove('is-select-dropdown-open');
    }
  });
});

(function() {
  var _original = window.selectCallback;
  window.selectCallback = function(productEl, product, variant, state) {
    if (variant && variant.featured_image) {
      var $product = $(productEl);
      var mediaId = variant.featured_media.id;
      var $sliders = $('.product-gallery__main, .js-gallery-modal', $product);
      $sliders.each(function(_, value) {
        var $slider = $(value);
        var $sliderInstance = window.Flickity.data(value);
        var index = $('img[data-image-id=' + mediaId + ']', $product).data('index');
        if ($slider.is(':visible') && $sliderInstance !== undefined && index !== undefined) {
          $sliderInstance.select(index, false, true);
        }
      });
    }
    var savedImage = variant ? variant.featured_image : null;
    if (variant) variant.featured_image = null;
    _original(productEl, product, variant, state);
    if (variant) variant.featured_image = savedImage;
  };
})();

// Fix: intercept metal label placement at DOM level — no delay, no flash
(function() {
  var busy = false;

  function fixMetalLabel() {
    if (busy) return;
    var swatchVal = document.querySelector('.selected-color-swatch-val');
    if (!swatchVal) return;
    var metalLabel = document.querySelector('[data-variant-option-name="Metal"]');
    if (!metalLabel) return;
    if (swatchVal.previousElementSibling === metalLabel) return;
    busy = true;
    metalLabel.parentNode.insertBefore(swatchVal, metalLabel.nextSibling);
    busy = false;
  }

  var observer = new MutationObserver(function() {
    if (!busy) fixMetalLabel();
  });

  function init() {
    var container = document.querySelector('.variant-selection, .shopify-product-form');
    if (container) observer.observe(container, { childList: true, subtree: true });
    fixMetalLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// Replace Cut dropdown with inline text buttons
(function() {
  function initCutButtons() {
    var cutLabel = document.querySelector('[data-variant-option-name="Cut"]');
    if (!cutLabel) return;
    var form = document.querySelector('form.shopify-product-form');
    if (!form) return;
    var cutSelect = Array.from(form.querySelectorAll('select.single-option-selector'))
      .find(function(s) {
        return Array.from(s.options).some(function(o) {
          return o.value === 'Emerald' || o.value === 'Pear';
        });
      });
    if (!cutSelect || cutSelect.dataset.cutInit) return;
    cutSelect.dataset.cutInit = 'true';

    var selectWrapper = cutSelect.closest('.custom-select, .select__wrapper') || cutSelect.parentElement;
    selectWrapper.style.display = 'none';

    var btnContainer = document.createElement('div');
    btnContainer.style.cssText = 'display:flex;gap:24px;margin-top:8px;';

    function updateButtons() {
      Array.from(btnContainer.querySelectorAll('span')).forEach(function(btn) {
        btn.style.borderBottom = btn.dataset.val === cutSelect.value
          ? '1px solid #111111' : 'none';
      });
    }

    Array.from(cutSelect.options).filter(function(o) { return o.value; }).forEach(function(opt) {
      var btn = document.createElement('span');
      btn.textContent = opt.value;
      btn.dataset.val = opt.value;
      btn.style.cssText = 'cursor:pointer;font-family:"Lato",sans-serif;font-size:1rem;font-weight:300;color:#111111;padding-bottom:3px;';
      btn.addEventListener('click', function() {
        cutSelect.value = opt.value;
        cutSelect.dispatchEvent(new Event('change', {bubbles: true}));
        updateButtons();
      });
      btnContainer.appendChild(btn);
    });

    cutSelect.addEventListener('change', updateButtons);
    selectWrapper.parentNode.insertBefore(btnContainer, selectWrapper.nextSibling);
    updateButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initCutButtons, 400); });
  } else {
    setTimeout(initCutButtons, 400);
  }
})();
// Close mini cart when overlay is clicked
document.addEventListener('click', function(e) {
  if (e.target && e.target.closest && e.target.closest('[data-site-overlay]')) {
    var cart = document.querySelector('.ajax-cart');
    if (cart) cart.classList.remove('ajax-cart--is-open');
  }
});